import { getProfile } from "./getProfile"

const profile = getProfile(process.env.NEXT_PUBLIC_PROFILE)

export default profile
